import React from "react";
import { Selector, Text, FrameIcon } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";
import { LogoutWrapper, Spacer } from "../styles/Styled";

export const Logout = ({ confirmationOptions, onItemSelected, isFromSettingsPage }) => {
  return (
    <LogoutWrapper>
      <FrameIcon name="logout" />
      <Text rank="1" text={i18n.get("pages.settings.logout.title")} size="xmedium" />
      <Spacer mb={1} />
      <Text text={i18n.get("pages.settings.logout.device")} />
      <Spacer mb={1} />
      <Selector
        items={confirmationOptions}
        onItemSelected={onItemSelected}
        isFromSettingsPage={isFromSettingsPage}
        size={isFromSettingsPage ? "xmedium" : "default"}
      />
    </LogoutWrapper>
  );
};
